module.exports = __webpack_public_path__ + "static/media/grafico-producao-mundial.326876d9.png";